'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { MarketRowCardView } from '@/components/markets/market-row-card';
import { buildShowcaseOutcomes, PREVIEW_CONSENSUS_THRESHOLD_D9, type ShowcaseMarketConfig } from '@/components/support-mainnet/markets-showcase/fixture';
export function StaticShowcaseCard(t0) {
  const $ = _c(14);
  const {
    market,
    title,
    testId
  } = t0;
  let t1;
  if ($[0] !== market) {
    t1 = buildShowcaseOutcomes(market, market.frozenState);
    $[0] = market;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const outcomes = t1;
  let t2;
  if ($[2] !== market.category || $[3] !== market.cover || $[4] !== market.frozenState.prizePoolD6 || $[5] !== market.frozenState.volumeTotalD6 || $[6] !== market.location || $[7] !== market.pubkeySuffix || $[8] !== outcomes || $[9] !== title) {
    t2 = <MarketRowCardView linkDisabled={true} pubkey={market.pubkeySuffix} title={title} coverImageUrl={market.cover} coverImageNsfw={false} location={market.location} category={market.category} volumeTotal={market.frozenState.volumeTotalD6} prizePool={market.frozenState.prizePoolD6} outcomes={outcomes} position={0} activeSort="volume24h" consensusThreshold={PREVIEW_CONSENSUS_THRESHOLD_D9} suppressOutcomeReveal={true} />;
    $[2] = market.category;
    $[3] = market.cover;
    $[4] = market.frozenState.prizePoolD6;
    $[5] = market.frozenState.volumeTotalD6;
    $[6] = market.location;
    $[7] = market.pubkeySuffix;
    $[8] = outcomes;
    $[9] = title;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== t2 || $[12] !== testId) {
    t3 = <div className="pointer-events-none w-[316px]" data-testid={testId}>{t2}</div>;
    $[11] = t2;
    $[12] = testId;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}